export const GTF_LOGO = "https://customer-assets.emergentagent.com/job_farmly-connect/artifacts/i2kddnib_ChatGPT%20Image%20Nov%2026%2C%202025%2C%2005_59_04%20PM.png";

export default function GTFLogo({ size = 40, showText = false, textVariant = "dark", className = "" }) {
  const textColor = textVariant === "light" ? "text-white" : "text-emerald-800";
  const sub = textVariant === "light" ? "text-emerald-200/80" : "text-emerald-600/70";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={GTF_LOGO} alt="Grow Together Farmily" style={{ width: size, height: size }}
        className="rounded-2xl bg-white p-0.5 shadow-md object-contain" />
      {showText && (
        <div>
          <div className={`font-bold tracking-tight leading-none ${textColor}`} style={{ fontSize: size * 0.42 }}>Grow Together Farmily</div>
          <div className={`uppercase tracking-widest ${sub}`} style={{ fontSize: size * 0.22, marginTop: 2 }}>GTF Platform</div>
        </div>
      )}
    </div>
  );
}
